(() => {
  const STORAGE_KEY = 'kingdomRadioStateV2';
  const PLAYLIST_KEY = 'kingdomRadioPlaylistV2';
  const ACTIVATED_KEY = 'kingdomRadioActivatedV2';

  // Free releases download without a Shopify order. Fetching the file as a
  // blob prevents browsers from merely opening the MP3 in a playback tab.
  window.KingdomFreeDownload = async (sourceUrl, suggestedName) => {
    try {
      const url = new URL(sourceUrl, location.href);
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return;
      const response = await fetch(url.href);
      if (!response.ok) throw new Error('Download request failed');
      const blobUrl = URL.createObjectURL(await response.blob());
      const anchor = document.createElement('a');
      anchor.href = blobUrl;
      anchor.download = suggestedName || decodeURIComponent(url.pathname.split('/').pop()) || 'Kingdom-Music.mp3';
      document.body.append(anchor);
      anchor.click();
      anchor.remove();
      setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
    } catch (_) {
      // Some file hosts block cross-origin fetch. Still allow the listener to
      // access the audio in a separate tab without interrupting the radio.
      window.open(sourceUrl, '_blank', 'noopener,noreferrer');
    }
  };
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[data-kmr-free-download]');
    if (!link) return;
    event.preventDefault();
    window.KingdomFreeDownload(link.href);
  });

  // Shared across music-page cards and the sitewide player's product dialog.
  const initAlbum = () => {
    const modal = document.querySelector('[data-krp-album]');
    if (!modal) return;
    const covers = modal.querySelector('[data-album-covers]');
    const buy = modal.querySelector('[data-album-buy]');
    const storageKey = 'kingdomAlbumSelectionsV1';
    let selected = [];
    try { const saved = JSON.parse(localStorage.getItem(storageKey) || '[]'); if (Array.isArray(saved)) selected = saved.filter(s => s && /^\d+$/.test(String(s.id))).slice(0,10); } catch (_) {}
    const persist = () => { try { localStorage.setItem(storageKey,JSON.stringify(selected)); } catch (_) {} document.dispatchEvent(new CustomEvent('kingdom-album:changed',{detail:{count:selected.length, ids:selected.map(s=>s.id)}})); };
    const hide = () => {modal.hidden = true;};
    const dismiss = () => {hide();selected=[];persist();};
    const show = () => {
      if (selected.length !== 10) return;
      covers.replaceChildren();
      selected.forEach(song => {
        const tile = document.createElement('div'); tile.className = 'krp-album__tile';
        if (song.cover) {const img = document.createElement('img'); img.src = song.cover; img.alt = song.title || 'Song cover'; tile.append(img);}
        else tile.textContent = '♪';
        covers.append(tile);
      });
      const cfg = window.KingdomAlbumConfig || {};
      const variants = selected.map(song => `${song.id}:1`).join(',');
      const base = (cfg.cartBase || '/cart').replace(/\/$/,'');
      const discount = encodeURIComponent(cfg.discountCode || 'KINGDOMALBUM50');
      buy.href = `${base}/${variants}?discount=${discount}`;
      document.querySelector('[data-krp-dialog]')?.setAttribute('hidden','');
      modal.hidden = false;modal.querySelector('.krp-album__panel')?.focus();
    };
    const add = song => {
      if (!song || !/^\d+$/.test(String(song.id))) return false;
      if (selected.some(s => String(s.id) === String(song.id))) return false;
      if (selected.length >= 10) {show();return false;}
      selected.push({id:String(song.id),title:String(song.title||''),cover:String(song.cover||'')});
      persist();
      if (selected.length === 10) show();
      return true;
    };
    const remove = id => {
      const index = selected.findIndex(song => String(song.id) === String(id));
      if (index < 0) return false;
      selected.splice(index, 1);
      persist();
      return true;
    };
    const toggle = song => selected.some(s => String(s.id) === String(song?.id)) ? remove(song.id) : add(song);
    modal.querySelector('[data-album-dismiss]')?.addEventListener('click',dismiss);
    modal.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();dismiss();}});
    window.KingdomAlbum = {add,remove,toggle,show,getCount:()=>selected.length,has:(id)=>selected.some(s=>String(s.id)===String(id))};
    persist();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAlbum, {once:true}); else initAlbum();

  const init = () => {
    const player = document.getElementById('KingdomRadioPlayer');
    if (!player || player.dataset.ready === 'true') return;
    player.dataset.ready = 'true';

    const audio = player.querySelector('[data-krp-audio]');
    const art = player.querySelector('[data-krp-art]');
    const placeholder = player.querySelector('[data-krp-placeholder]');
    const title = player.querySelector('[data-krp-title]');
    const artist = player.querySelector('[data-krp-artist]');
    const toggle = player.querySelector('[data-krp-toggle]');
    const icon = player.querySelector('[data-krp-play-icon]');
    const current = player.querySelector('[data-krp-current]');
    const duration = player.querySelector('[data-krp-duration]');
    const progress = player.querySelector('[data-krp-progress]');
    const progressTrack = player.querySelector('[data-krp-progress-track]');
    const openCardButton = player.querySelector('[data-krp-open]');
    const dialog = document.querySelector('[data-krp-dialog]');
    const dialogCard = dialog?.querySelector('[data-krp-card]');
    const dialogPanel = dialog?.querySelector('[data-krp-panel]');
    let lastFocus = null;


    let playlist = [];
    let index = -1;
    let retainedSong = null; // Current audio may belong to the previous browsing collection.
    let lastSavedSecond = -1;

    const safeParse = (value, fallback) => {
      try { return JSON.parse(value) ?? fallback; } catch (_) { return fallback; }
    };
    const formatTime = (seconds) => {
      if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
      const mins = Math.floor(seconds / 60);
      return `${mins}:${String(Math.floor(seconds % 60)).padStart(2, '0')}`;
    };
    const getState = () => safeParse(localStorage.getItem(STORAGE_KEY), {});
    const isActivated = () => sessionStorage.getItem(ACTIVATED_KEY) === 'true';
    const activate = () => { try { sessionStorage.setItem(ACTIVATED_KEY, 'true'); } catch (_) {} };
    const savePlaylist = () => {
      try { localStorage.setItem(PLAYLIST_KEY, JSON.stringify(playlist)); } catch (_) {}
    };
    const saveState = (extra = {}) => {
      if (!retainedSong && (index < 0 || !playlist[index])) return;
      const state = {
        index,
        src: (retainedSong || playlist[index]).src,
        currentTime: Number.isFinite(audio.currentTime) ? audio.currentTime : 0,
        wasPlaying: !audio.paused && !audio.ended,
        updatedAt: Date.now(),
        ...extra
      };
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (_) {}
    };
    // Keep the card presentation driven by the same playlist item used by the radio.
    // Product checkout URLs are taken from the existing storefront song cards.
    const renderCard = () => {
      if (!dialogCard) return;
      const song = retainedSong || playlist[index];
      dialogCard.replaceChildren();
      if (!song) return;
      const card = document.createElement('article');
      card.className = 'krp-product';
      if (song.cover) {
        const img = document.createElement('img');
        img.className = 'krp-product__cover';
        img.src = song.cover;
        img.alt = song.title ? `${song.title} cover` : 'Cover art';
        card.append(img);
      }
      const content = document.createElement('div');
      content.className = 'krp-product__content';
      const genre = song.shop?.genre || song.genre;
      if (genre) {
        const p = document.createElement('p'); p.className = 'krp-product__genre'; p.textContent = genre; content.append(p);
      }
      const h = document.createElement('h2'); h.className = 'krp-product__title';
      h.textContent = song.shop?.title || song.title || 'Kingdom Music'; content.append(h);
      const byline = song.shop?.artist || song.artist;
      if (byline) { const p = document.createElement('p'); p.className = 'krp-product__artist'; p.textContent = byline; content.append(p); }
      const actions = document.createElement('div'); actions.className = 'krp-product__actions';
      // This modal is for shopping. Playback is already controlled by the radio.
      const purchaseActions = Array.isArray(song.shop?.actions) ? song.shop.actions : [];
      purchaseActions.forEach(action => {
        // Only allow URLs from the current shop, for checkout or configured actions.
        if (!action || !action.url) return;
        let url;
        try { url = new URL(action.url, location.origin); } catch (_) { return; }
        if (url.protocol !== 'https:' && url.protocol !== 'http:') return;
        const link = document.createElement('a'); link.className = 'krp-product__action krp-product__action--buy';
        const isFreeDownload = (action.label || '').trim() === 'Free Download';
        const isDiscovery = !!action.discovery;
        link.textContent = action.label || 'Buy now'; link.href = url.href;
        if (isDiscovery) {
          if (url.origin !== location.origin) { link.target = '_blank'; link.rel = 'noopener noreferrer'; }
        } else if (isFreeDownload) {
          link.setAttribute('download', '');
          link.addEventListener('click', event => { event.preventDefault(); window.KingdomFreeDownload(url.href); });
        } else {
          link.target = '_blank'; link.rel = 'noopener noreferrer';
        }
        actions.append(link);
      });
      if (!actions.children.length) {
        const notice = document.createElement('p');
        notice.className = 'krp-product__note';
        notice.textContent = 'This audio does not have a purchase link assigned.';
        actions.append(notice);
      }
      if (song.shop?.variantId && Number(song.shop.price) === 100 && !purchaseActions.some(action => action.label === 'Free Download') && window.KingdomAlbum) {
        const add = document.createElement('button');
        add.type = 'button'; add.className = 'krp-product__action krp-product__action--album';
        add.textContent = window.KingdomAlbum.has(song.shop.variantId) ? 'Added ✓' : 'Add to Album';
        add.setAttribute('aria-pressed', String(window.KingdomAlbum.has(song.shop.variantId)));
        add.addEventListener('click', () => {
          window.KingdomAlbum.toggle({id: String(song.shop.variantId), title: song.shop.title || song.title, cover: song.cover});
          add.textContent = window.KingdomAlbum.has(song.shop.variantId) ? 'Added ✓' : 'Add to Album';
          add.setAttribute('aria-pressed', String(window.KingdomAlbum.has(song.shop.variantId)));
          // The album manager opens the completion modal on song ten.
          // On songs 1–9 simply return to shopping; playback is unaffected.
          if (window.KingdomAlbum.getCount() === 10) {
            // Completion overlay already takes focus; hide the product overlay only.
            if (dialog) dialog.hidden = true;
          } else {
            closeCard();
          }
        });
        actions.append(add);
      }
      content.append(actions);
      if (song.shop?.description && purchaseActions.length) {
        const note = document.createElement('p'); note.className = 'krp-product__note'; note.textContent = song.shop.description; content.append(note);
      }
      card.append(content); dialogCard.append(card);
    };
    const closeCard = () => {
      if (!dialog || dialog.hidden) return;
      dialog.hidden = true;
      lastFocus?.focus?.();
    };
    const openCard = () => {
      if (!dialog || !playlist[index]) return;
      lastFocus = document.activeElement;
      renderCard(); dialog.dataset.currentSrc = playlist[index].src; dialog.hidden = false; dialogPanel?.focus();
    };
    openCardButton?.addEventListener('click', openCard);
    dialog?.querySelectorAll('[data-krp-close]').forEach(button => button.addEventListener('click', closeCard));
    dialog?.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); closeCard(); }
      if (event.key === 'Tab') {
        const focusables = [...dialog.querySelectorAll('button, a[href]')].filter(el => !el.disabled);
        if (!focusables.length) return;
        const first = focusables[0], last = focusables[focusables.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
    const updateUI = () => {
      const song = retainedSong || playlist[index];
      if (!song) return;
      const state = getState();
      player.hidden = !isActivated();
      title.textContent = song.title || 'Kingdom Music Radio';
      artist.textContent = song.artist || song.genre || 'Kingdom Music Radio';
      if (song.cover) {
        art.src = song.cover;
        art.alt = song.title ? `${song.title} cover art` : 'Song cover art';
        art.hidden = false;
        placeholder.hidden = true;
      } else {
        art.removeAttribute('src');
        art.hidden = true;
        placeholder.hidden = false;
      }
      const playing = !audio.paused && !audio.ended;
      icon.textContent = playing ? '❚❚' : '▶';
      toggle.setAttribute('aria-label', playing ? 'Pause' : 'Play');
      current.textContent = formatTime(audio.currentTime);
      duration.textContent = formatTime(audio.duration);
      progress.style.width = audio.duration ? `${Math.min(100, (audio.currentTime / audio.duration) * 100)}%` : '0%';
      if (dialog && !dialog.hidden && dialog.dataset.currentSrc !== song.src) { dialog.dataset.currentSrc = song.src; renderCard(); }
      document.dispatchEvent(new CustomEvent('kingdom-radio:state', { detail: { index, song, playing } }));
    };
    const loadIndex = async (newIndex, { autoplay = true, time = 0 } = {}) => {
      if (!playlist.length) return;
      index = (newIndex + playlist.length) % playlist.length;
      retainedSong = null;
      const song = playlist[index];
      if (!song?.src) return;
      if (audio.src !== song.src) audio.src = song.src;
      const setTime = () => {
        if (Number.isFinite(time) && time > 0 && Number.isFinite(audio.duration)) {
          audio.currentTime = Math.min(time, Math.max(0, audio.duration - .25));
        }
      };
      if (audio.readyState >= 1) setTime();
      else audio.addEventListener('loadedmetadata', setTime, { once: true });
      updateUI();
      if (autoplay) {
        try { await audio.play(); } catch (_) { updateUI(); }
      }
      saveState({ wasPlaying: autoplay, currentTime: Number.isFinite(time) ? time : (audio.currentTime || 0) });
    };
    const setPlaylist = (incoming) => {
      if (!Array.isArray(incoming) || !incoming.length) return;
      const previousSrc = retainedSong?.src || playlist[index]?.src || getState().src;
      const previousSong = retainedSong || playlist[index];
      const previousSongs = new Map(playlist.map(song => [song.src, song]));
      playlist = incoming.filter((song) => song && song.src).map(song => {
        const prior = previousSongs.get(song.src);
        const incomingActions = song.shop?.actions;
        // Never erase valid purchase actions when another source publishes an incomplete playlist.
        if ((!Array.isArray(incomingActions) || !incomingActions.length) && prior?.shop?.actions?.length) {
          return { ...song, shop: { ...song.shop, actions: prior.shop.actions } };
        }
        return song;
      });
      savePlaylist();
      if (previousSrc) {
        const matching = playlist.findIndex((song) => song.src === previousSrc);
        if (matching >= 0) {index = matching;retainedSong = null;}
        else if (previousSong && audio.src) {retainedSong = previousSong;index = -1;}
        else {retainedSong = null;index = -1;}
      }
    };

    window.KingdomRadio = {
      setPlaylist,
      play: async (requestedIndex) => {
        if (!playlist.length) return;
        const prior = getState();
        activate();
        try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...prior, updatedAt: Date.now() })); } catch (_) {}
        player.hidden = false;
        const requested = Number.isInteger(requestedIndex) ? requestedIndex : (index >= 0 ? index : 0);
        if (requested !== index || retainedSong || !audio.src) await loadIndex(requested, { autoplay: true });
        else { try { await audio.play(); } catch (_) {} }
      },
      pause: () => audio.pause(),
      toggle: async () => {
        if (!playlist.length) return;
        if (index < 0) return loadIndex(0, { autoplay: true });
        if (audio.paused) { try { await audio.play(); } catch (_) {} } else audio.pause();
      },
      next: () => loadIndex(index < 0 ? 0 : index + 1, { autoplay: true }),
      prev: () => loadIndex(index < 0 ? 0 : index - 1, { autoplay: true }),
      getState: () => ({ playlist, index, playing: !audio.paused, song: retainedSong || playlist[index] || null })
    };

    toggle.addEventListener('click', () => window.KingdomRadio.toggle());
    player.querySelector('[data-krp-next]').addEventListener('click', () => window.KingdomRadio.next());
    player.querySelector('[data-krp-prev]').addEventListener('click', () => window.KingdomRadio.prev());
    progressTrack.addEventListener('click', (event) => {
      if (!audio.duration) return;
      const rect = progressTrack.getBoundingClientRect();
      audio.currentTime = Math.max(0, Math.min(audio.duration, ((event.clientX - rect.left) / rect.width) * audio.duration));
    });

    audio.addEventListener('play', () => { updateUI(); saveState({ wasPlaying: true }); });
    audio.addEventListener('pause', () => { updateUI(); saveState({ wasPlaying: false }); });
    audio.addEventListener('loadedmetadata', updateUI);
    audio.addEventListener('timeupdate', () => {
      updateUI();
      const second = Math.floor(audio.currentTime);
      if (second !== lastSavedSecond && second % 3 === 0) {
        lastSavedSecond = second;
        saveState();
      }
    });
    audio.addEventListener('ended', () => window.KingdomRadio.next());
    window.addEventListener('pagehide', () => saveState());

    document.addEventListener('kingdom-radio:playlist', (event) => setPlaylist(event.detail));
    document.addEventListener('kingdom-radio:play-index', (event) => window.KingdomRadio.play(event.detail?.index));

    const storedPlaylist = safeParse(localStorage.getItem(PLAYLIST_KEY), []);
    const state = getState();
    if (storedPlaylist.length && state.src && isActivated()) {
      setPlaylist(storedPlaylist);
      const restoredIndex = playlist.findIndex((song) => song.src === state.src);
      if (restoredIndex >= 0) {
        loadIndex(restoredIndex, { autoplay: false, time: state.currentTime || 0 }).then(async () => {
          if (state.wasPlaying) {
            try { await audio.play(); } catch (_) {
              // Browser autoplay rules may require one tap after a full page navigation.
              updateUI();
            }
          }
        });
      }
    }

    document.dispatchEvent(new CustomEvent('kingdom-radio:ready'));
  };

  // The player markup is rendered before the page sections, so initialize immediately.
  // This guarantees window.KingdomRadio exists before the Kingdom Music section's inline script runs.
  init();
})();
